module.exports = __webpack_public_path__ + "img/12.788c20da.png";